<template>
  <span>
    <div id="app">
      <v-app light>
        <v-toolbar
          :extended="$vuetify.breakpoint.smAndDown"
          color="bolsa-guinda"
          v-if="$vuetify.breakpoint.smAndDown"
          style="height: 140px"
        >
          <div class="navbar-left">
            <a href="https://www.uni.edu.pe" target="_blank">
              <img class="navbar-left-image" src="../../assets/logo_uni.png" />
            </a>
          </div>
          <v-toolbar-title class="logo--text" v-text="title"></v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <div class="d-flex flex-column align-start">
              <v-btn
                small
                text
                color="white"
                class="my-1"
                :to="{ name: 'RegistroAlumno' }">
                <v-icon left>mdi-account-plus</v-icon>Registrate Aquí
              </v-btn>
              <v-btn
                small
                text
                color="white"
                class="my-1"
                :to="{ name: 'Reestablecer Cuenta' }">
                <v-icon left>mdi-lock-reset</v-icon>Recuperar Contraseña
              </v-btn>
              <v-btn
                v-if="isAdmin"
                small
                text
                color="white"
                class="my-1"
                :to="{ path: '/admin' }">
                <v-icon left>mdi-badge-account</v-icon>Acceder como administrador</v-btn>
            </div>
          </v-toolbar-items>
        </v-toolbar>
        <v-toolbar color="bolsa-guinda" v-else>
          <div class="navbar-left">
            <a href="https://www.uni.edu.pe" target="_blank">
              <img class="navbar-left-image" src="../../assets/logo_uni.png" />
            </a>
          </div>
          <v-toolbar-title class="logo--text" v-text="title"></v-toolbar-title>
          <v-spacer></v-spacer>

          <v-toolbar-items>
            <v-btn text color="white" :to="{ name: 'RegistroAlumno' }">
              <v-icon left>mdi-account-plus</v-icon>Registrate Aquí
            </v-btn>
            <v-btn text color="white" :to="{ name: 'Reestablecer Cuenta' }">
              <v-icon left>mdi-lock-reset</v-icon>¿Olvidaste tu Contraseña?
            </v-btn>
            <v-btn
              v-if="isAdmin"
              small
              text
              color="white"
              :to="{ path: '/admin' }"
              ><v-icon>mdi-badge-account</v-icon> Acceder como
              administrador</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-main>
          <section>
            <v-snackbar
              v-model="showSnackbar"
              color="error"
              top
              right
              :timeout="3500">
              {{
                getError.error == ''
                  ? getError.errorMessage
                  : getAuthError.authErrorMessage
              }}
              <!-- <v-btn color="white" text>Cerrar</v-btn> -->
            </v-snackbar>
            <v-snackbar
              v-model="getAuthError.error"
              color="error"
              top
              right
              :timeout="3500">
              {{ getAuthError.authErrorMessage }}
              <!-- <v-btn color="white" text>Cerrar</v-btn> -->
            </v-snackbar>
            <v-parallax src="../../assets/img.jpg" contain height="450">
              <v-container class="fill-height" fluid>
                <v-row
                  v-if="!loggedIn"
                  align="center"
                  :justify="$vuetify.breakpoint.mdAndUp ? 'end' : 'center'">
                  <v-col cols="12" sm="8" md="4">
                    <v-card class="elevation-12" id="cardLogin">
                      <v-card-title class="pa-1">
                        <v-tabs
                          v-model="IndexTab"
                          grow
                          centered
                          color="#1976D2"
                        >
                          <v-tab
                            v-for="(tab, i) in tabs"
                            :key="i"
                            :href="'#tab' + tab.name"
                            class="ml-0"
                            >{{ tab.name }}</v-tab
                          >
                        </v-tabs>
                      </v-card-title>
                      <v-card-text>
                        <v-tabs-items v-model="IndexTab">
                          <v-tab-item
                            transition="scroll-y-transition"
                            reverse-transition="scroll-y-transition"
                            id="tabAlumno">
                            <v-container fluid class="pa-1">
                              <v-card flat>
                                <v-form
                                  ref="studentLogin"
                                  v-model="validStudentForm"
                                  lazy-validation
                                  @submit.prevent="handleStudentSubmit">
                                  <v-text-field
                                    label="Código o correo UNI"
                                    name="username"
                                    prepend-icon="mdi-account"
                                    type="text"
                                    placeholder="alumno@uni.pe"
                                    filled
                                    rounded
                                    dense
                                    :rules="studentUserRules"
                                    v-model="studentForm.username"
                                  ></v-text-field>
                                  <v-text-field
                                    label="Contraseña"
                                    name="password"
                                    prepend-icon="mdi-lock"
                                    type="password"
                                    placeholder="******"
                                    filled
                                    rounded
                                    dense
                                    :rules="passwordRules"
                                    v-model="studentForm.password"
                                  ></v-text-field>
                                  <v-alert
                                    dense
                                    border="left"
                                    class="mx-2 mt-1 mb-0"
                                    type="error"
                                    transition="scale-transition"
                                    v-if="isAuthError"
                                    >{{ AuthenticationError }}</v-alert
                                  >
                                  <v-card-actions>
                                    <v-btn
                                      block
                                      color="#1976D2"
                                      class="white--text mt-2"
                                      type="submit"
                                      :loading="loggingIn"
                                      :disabled="loggingIn"
                                      >Entrar</v-btn
                                    >
                                  </v-card-actions>
                                </v-form>
                              </v-card>
                            </v-container>
                          </v-tab-item>
                          <v-tab-item
                            transition="scroll-y-transition"
                            reverse-transition="scroll-y-transition"
                            id="tabEmpresa">
                            <v-container class="pa-1">
                              <v-card flat>
                                <v-form
                                  ref="empresaLogin"
                                  v-model="validEmpresaForm"
                                  lazy-validation
                                  @submit.prevent="handleEmpresaSubmit">
                                  <v-text-field
                                    label="RUC"
                                    name="ruc"
                                    prepend-icon="mdi-domain"
                                    type="text"
                                    :rules="rucEmpresaRules"
                                    filled
                                    rounded
                                    dense
                                    v-model="empresaForm.ruc">
                                  </v-text-field>
                                  <v-text-field
                                    label="Usuario Empresa"
                                    name="username"
                                    prepend-icon="mdi-account"
                                    type="text"
                                    filled
                                    rounded
                                    dense
                                    :rules="userEmpresaRules"
                                    v-model="empresaForm.username">
                                  </v-text-field>
                                  <v-text-field
                                    label="Contraseña"
                                    name="password"
                                    prepend-icon="mdi-lock"
                                    type="password"
                                    :rules="passwordRules"
                                    placeholder="******"
                                    filled
                                    rounded
                                    dense
                                    v-model="empresaForm.password"
                                  ></v-text-field>
                                  <v-alert
                                    dense
                                    border="left"
                                    class="mx-2 mt-1 mb-0"
                                    type="error"
                                    transition="scale-transition"
                                    v-if="isAuthError">{{ AuthenticationError }}
                                  </v-alert>
                                  <v-card-actions>
                                    <v-btn
                                      block
                                      color="#0C2ACB"
                                      type="submit"
                                      class="white--text"
                                      :loading="loggingIn"
                                      :disabled="loggingIn">Entrar</v-btn>
                                  </v-card-actions>
                                </v-form>
                              </v-card>
                            </v-container>
                          </v-tab-item>
                        </v-tabs-items>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row v-else align="center" justify="center">
                  <template v-if="getRoleToken == 'user'">
                    <v-btn
                      x-large
                      dark
                      color="bolsa-guinda"
                      :to="{ name: 'Trabajos' }"
                    >
                      <v-icon left>mdi-home</v-icon>Ir a la Página Principal
                    </v-btn>
                  </template>
                  <template v-else-if="getRoleToken == 'company'">
                    <v-btn
                      x-large
                      color="info"
                      :to="{ name: 'Inicio Empresas' }"
                    >
                      <v-icon left>mdi-home</v-icon>Ir a la Página Principal
                    </v-btn>
                  </template>
                  <template v-else>
                    <v-btn x-large color="success" :to="{ name: 'Trabajos' }">
                      <v-icon left>mdi-home</v-icon>Ir a la Página Principal
                    </v-btn>
                  </template>
                </v-row>
              </v-container>
            </v-parallax>
          </section>

          <section>
            <v-layout column wrap class="my-12" align-center>
              <v-flex xs12 sm4 class="my-4">
                <div class="text-center">
                  <p class="headline">
                    Plataforma de Inserción y seguimiento al graduado UNI -
                    AlumniUNI
                  </p>
                </div>
              </v-flex>
              <v-flex xs12>
                <v-container grid-list-xl>
                  <v-layout row wrap align-center>
                    <v-flex xs12 md4>
                      <v-card flat class="transparent">
                        <v-card-text class="text-center py-0">
                          <v-icon x-large color="bolsa-guinda"
                            >mdi-school</v-icon
                          >
                        </v-card-text>
                        <v-card-title
                          primary-title
                          class="layout justify-center">
                          <div class="headline text-center">Egresados</div>
                        </v-card-title>
                        <v-card-text class="text-justify my-3">
                          Más de +12,000 graduados que forman parte de la
                          comunidad UNI.
                        </v-card-text>
                      </v-card>
                    </v-flex>
                    <v-flex xs12 md4>
                      <v-card flat class="transparent">
                        <v-card-text class="text-center py-0">
                          <v-icon x-large color="bolsa-guinda">mdi-account-tie-voice</v-icon>
                        </v-card-text>
                        <v-card-title primary-title class="layout justify-center">
                          <div class="headline" @click="handleGoToBolsaTrabajo" style="cursor: pointer;">Bolsa de Trabajo</div>
                        </v-card-title>
                        <v-card-text class="text-justify my-3">
                          La plataforma cuenta con el sistema de inserción
                          laboral de los graduados UNI.
                        </v-card-text>
                      </v-card>
                    </v-flex>
                    <v-flex xs12 md4>
                      <v-card flat class="transparent">
                        <v-card-text class="text-center py-0">
                          <v-icon x-large color="bolsa-guinda"
                            >mdi-head-check-outline</v-icon
                          >
                        </v-card-text>
                        <v-card-title
                          primary-title
                          class="layout justify-center"
                        >
                          <div class="headline text-center">
                            Evaluación por Competencias
                          </div>
                        </v-card-title>
                        <v-card-text class="text-justify pt-2">
                          La plataforma cuenta con un sistema de evaluación de
                          competencias generales, que le permite al graduado
                          medir su nivel de desarrollo.
                        </v-card-text>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-flex>
            </v-layout>
          </section>

          <section>
            <v-parallax src="../../assets/uni.jpg" height="400"></v-parallax>
          </section>

          <section>
            <v-container grid-list-xl>
              <v-layout row wrap justify-center class="my-12">
                <v-flex xs12 sm4>
                  <v-card flat class="transparent">
                    <v-card-title primary-title class="layout justify-center">
                      <div class="headline">Seguimiento al Graduado UNI</div>
                    </v-card-title>
                    <v-card-text class="text-justify">
                      El área de Seguimiento al Graduado del a UNI forma parte
                      del CEPS UNI, lo cual promueve la conexión, localización,
                      inserción laboral y actualización de datos de los
                      graduados de la UNI.
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs12 sm4 offset-sm1>
                  <v-card flat class="transparent">
                    <v-card-title primary-title class="layout justify-center">
                      <div class="headline">Contáctanos</div>
                    </v-card-title>
                    <v-list class="transparent" disabled>
                      <v-list-item disabled>
                        <v-list-item-action>
                          <v-icon class="bolsa-guinda--text text--lighten-2"
                            >mdi-map-marker</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title style="white-space: normal">
                            Cruce de las avenidas Túpac Amaru y Eduardo de
                            Habich, Puerta 04-A
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item disabled>
                        <v-list-item-action>
                          <v-icon class="bolsa-guinda--text text--lighten-2">mdi-email</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title>seguimientoalgraduado@uni.edu.pe</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item disabled>
                        <v-list-item-action>
                          <v-icon class="bolsa-guinda--text text--lighten-2">mdi-phone</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title>01 4811070 Anexo 7106</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </section>

          <section>
            <NewsList />
          </section>

          <v-footer color="#9a999d">
            <v-layout row wrap align-center>
              <v-flex xs12>
                <a class="white--text ml-4">Términos y Condiciones de uso</a>
              </v-flex>
            </v-layout>
          </v-footer>
        </v-main>
      </v-app>
    </div>
  </span>
</template>

<script>
import { mapGetters } from 'vuex';
import NewsList from '../../components/home/NewsList.vue';

export default {
  name: 'landing',
  components: {
    NewsList
  },
  data () {
    return {
      title: 'AlumniUNI',
      IndexTab: 'tabAlumno',
      authError: '',
      authErrorMessage: '',
      loadingAuth: false,
      closedErrorSnackbar: true,
      errorSnackbarMessage: '',
      tabs: [
        {
          name: 'Alumno'
        },
        {
          name: 'Empresa'
        }
      ],
      studentForm: {
        username: '',
        password: ''
      },
      empresaForm: {
        ruc: '',
        username: '',
        password: ''
      },
      validStudentForm: false,
      validEmpresaForm: false,
      studentUserRules: [(v) => !!v || 'Código o Correo UNI requerido'],
      userEmpresaRules: [
        (v) => !!v || 'Documento de usuario requerido'
        // (v) => (!!v && v.length == 8) || "El documento tiene 8 caracteres"
      ],
      rucEmpresaRules: [
        (v) => !!v || 'Código o Correo UNI requerido',
        (v) => (!!v && v.length === 11) || 'El RUC tiene 11 caracteres'
      ],
      passwordRules: [(v) => !!v || 'La contraseña es requerida']
    };
  },
  methods: {
    handleStudentSubmit () {
      if (this.$refs.studentLogin.validate()) {
        this.authError = '';
        this.$store
          .dispatch('auth/login', {
            username: this.studentForm.username,
            password: this.studentForm.password
          })
          .then(() => {
            if (this.$store.state.auth.AuthenticationError) {
              this.authError = this.$store.state.auth.AuthenticationError;
            }
          });
      }
    },

    handleEmpresaSubmit () {
      if (this.$refs.empresaLogin.validate()) {
        this.authError = '';
        this.$store
          .dispatch('auth/loginEmpresa', {
            ruc: this.empresaForm.ruc,
            username: this.empresaForm.username,
            password: this.empresaForm.password
          })
          .then(() => {
            if (this.$store.state.auth.AuthenticationError) {
              this.authError = this.$store.state.auth.AuthenticationError;
            }
          });
      }
    },

    handleGoToBolsaTrabajo () {
      window.open('https://bolsatrabajo.uni.edu.pe');
    }
  },
  computed: {
    isAuthError () {
      if (this.AuthenticationError !== '') return true;
      else return false;
    },

    loggingIn () {
      return this.$store.state.auth.authenticating;
    },

    isAdmin () {
      const admaccess = localStorage.getItem('admaccess');
      return admaccess === 'true';
    },

    ...mapGetters('auth', ['loggedIn', 'AuthenticationError']),

    ...mapGetters('user', [
      'isValidToken',
      'getError',
      'getAuthError',
      'getRoleToken'
    ]),

    showSnackbar () {
      return !this.isValidToken && !this.closedErrorSnackbar;
    }
  },
  mounted () {
    this.authError = this.getError.error;
    this.authErrorMessage = this.getError.errorMessage;
  },
  watch: {}
};
</script>
<style>
.navbar-left {
  height: 100%;
  padding: 5px 0;
  margin: 0 10px;
}
.navbar-left-image {
  height: 100%;
  width: auto;
}
.v-toolbar__title.logo--text {
  color: white;
}

.wrap-text {
  -webkit-line-clamp: unset !important;
}
</style>
